import { render, staticRenderFns } from "./vsm_mobile_filter_chips.vue?vue&type=template&id=1a1f5594&"
import script from "./vsm_mobile_filter_chips.vue?vue&type=script&lang=js&"
export * from "./vsm_mobile_filter_chips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports